import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.reduce.js";

var e = {
  data: ""
},
    t = function t(_t) {
  return "undefined" != typeof window ? ((_t ? _t.querySelector("#_goober") : window._goober) || Object.assign((_t || document.head).appendChild(document.createElement("style")), {
    innerHTML: " ",
    id: "_goober"
  })).firstChild : _t || e;
},
    r = function r(e) {
  var r = t(e),
      l = r.data;
  return r.data = "", l;
},
    l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(})/g,
    a = /\/\*[^]*?\*\/|\s\s+|\n/g,
    n = function n(e, t) {
  var r,
      l = "",
      a = "",
      o = "";

  var _loop = function _loop(_c2) {
    var s = e[_c2];
    "object" == typeof s ? (r = t ? t.replace(/([^,])+/g, function (e) {
      return _c2.replace(/([^,])+/g, function (t) {
        return /&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t;
      });
    }) : _c2, a += "@" == _c2[0] ? "f" == _c2[1] ? n(s, _c2) : _c2 + "{" + n(s, "k" == _c2[1] ? "" : t) + "}" : n(s, r)) : "@" == _c2[0] && "i" == _c2[1] ? l = _c2 + " " + s + ";" : (_c2 = _c2.replace(/[A-Z]/g, "-$&").toLowerCase(), o += n.p ? n.p(_c2, s) : _c2 + ":" + s + ";");
    _c = _c2;
  };

  for (var _c in e) {
    _loop(_c);
  }

  return o[0] ? (r = t ? t + "{" + o + "}" : o, l + r + a) : l + a;
},
    o = {},
    c = function c(e) {
  var t = "";

  for (var _r in e) {
    t += _r + ("object" == typeof e[_r] ? c(e[_r]) : e[_r]);
  }

  return t;
},
    s = function s(e, t, r, _s, i) {
  var p = "object" == typeof e ? c(e) : e,
      u = o[p] || (o[p] = function (e) {
    var t = 0,
        r = 11;

    for (; t < e.length;) {
      r = 101 * r + e.charCodeAt(t++) >>> 0;
    }

    return "go" + r;
  }(p));

  if (!o[u]) {
    var _t2 = "object" == typeof e ? e : function (e) {
      var t,
          r = [{}];

      for (; t = l.exec(e.replace(a, ""));) {
        t[4] && r.shift(), t[3] ? r.unshift(r[0][t[3]] = r[0][t[3]] || {}) : t[4] || (r[0][t[1]] = t[2]);
      }

      return r[0];
    }(e);

    o[u] = n(i ? _defineProperty({}, "@keyframes " + u, _t2) : _t2, r ? "" : "." + u);
  }

  return function (e, t, r) {
    -1 == t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
  }(o[u], t, _s), u;
},
    i = function i(e, t, r) {
  return e.reduce(function (e, l, a) {
    var o = t[a];

    if (o && o.call) {
      var _e = o(r),
          _t3 = _e && _e.props && _e.props.className || /^go/.test(_e) && _e;

      o = _t3 ? "." + _t3 : _e && "object" == typeof _e ? _e.props ? "" : n(_e, "") : _e;
    }

    return e + l + (null == o ? "" : o);
  }, "");
};

function p(e) {
  var r = this || {},
      l = e.call ? e(r.p) : e;
  return s(l.unshift ? l.raw ? i(l, [].slice.call(arguments, 1), r.p) : l.reduce(function (e, t) {
    return t ? Object.assign(e, t.call ? t(r.p) : t) : e;
  }, {}) : l, t(r.target), r.g, r.o, r.k);
}

var u,
    f,
    d,
    g = p.bind({
  g: 1
}),
    b = p.bind({
  k: 1
});

function h(e, t, r, l) {
  n.p = t, u = e, f = r, d = l;
}

function y(e, t) {
  var r = this || {};
  return function () {
    var l = arguments;

    function a(n, o) {
      var c = Object.assign({}, n),
          s = c.className || a.className;
      r.p = Object.assign({
        theme: f && f()
      }, c), r.o = / *go\d+/.test(s), c.className = p.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
      var i = c.as || e;
      return d && i[0] && d(c), u(i, c);
    }

    return t ? t(a) : a;
  };
}

export { p as css, r as extractCss, g as glob, b as keyframes, h as setup, y as styled };